import { render, staticRenderFns } from "./ChangePasswordSuccess.vue?vue&type=template&id=0337f336&scoped=true"
import script from "./ChangePasswordSuccess.vue?vue&type=script&lang=js"
export * from "./ChangePasswordSuccess.vue?vue&type=script&lang=js"
import style0 from "./ChangePasswordSuccess.vue?vue&type=style&index=0&id=0337f336&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0337f336",
  null
  
)

export default component.exports